<template>
  <button
    :class="classList"
    :disabled="disabled"
    class="c-button a-static flex items-center px-4 py-2 text-sm font-medium leading-5 truncate rounded-md border shadow-sm active:shadow"
  >
    {{ text }}
    <slot/>
  </button>
</template>

<script>
import { props } from './props'
import { computed } from 'vue'

export default {
  name: 'CButton',
  props,
  setup (props) {
    const classList = computed(() => {
      let color

      if (props.color === 'primary' || props.selected) {
        color = 'text-primary-button bg-primary-overlay border-primary-outline hover:bg-primary-hover'
      } else if (props.color === 'disabled' || props.disabled) {
        color = 'text-disabled-disabled border-disabled-outline-disabled'
      } else {
        switch (props.color) {
          case 'secondary':
            color = 'text-secondary-button bg-secondary-overlay border-secondary-outline hover:bg-secondary-hover'
            break
          case 'success':
            color = 'text-success-button bg-success-overlay border-success-outline hover:bg-success-hover'
            break
          case 'info':
            color = 'text-info-button bg-info-overlay border-info-outline hover:bg-info-hover'
            break
          case 'warning':
            color = 'text-warning-button bg-warning-overlay border-warning-outline hover:bg-warning-hover'
            break
          case 'error':
            color = 'text-error-button bg-error-overlay border-error-outline hover:bg-error-hover'
            break
          default:
            color = 'text-basic-button bg-white border-basic-outline hover:bg-basic-hover'
            break
        }
      }

      return {
        [color]: true
      }
    })

    return {
      classList
    }
  }
}
</script>

<style lang="scss"/>
